<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";
import Multiselect from "@vueform/multiselect";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations, DxHeaderFilter

} from 'devextreme-vue/data-grid';
import moment from "moment/moment";
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {

  components: {
    Layout, PageHeader, DxDataGrid, DxColumn, DxButton,
    DxColumnChooser, DxColumnFixing, DxSelection, DxExport, DxStateStoring, DxGroupPanel, DxGrouping,
    DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations, DxHeaderFilter, Multiselect
  },

  data() {

    return {
      title: "Cotações Internas",
      items: [
        {
          text: "Fretes",
          href: "/"
        },
        {
          text: "Cotações Internas",
          active: true
        }
      ],
      dataList: null,
      dtIniFiltro: null,
      dtFimFiltro: null,
      showModalPeriodo: false,
      submittedPeriodo: false,
      showMovalAssocMov: false,
      idMovAssoc: 0,
      dtListPesqMov: null,
      idsAtualizar: null

    };
  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted cotafrt-list_0')
    this.atualizaDataList()
  },


  methods: {


    abrirCotaExterna(){
      console.log('abrirCotaExterna')
      const routeData = this.$router.resolve(`/cotafrts/listexterna`)
      window.open(routeData.href, '_blank')
    },


    pesqMovimento(evt){
      console.log('pesqMovimento')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/movpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqMov = res.data
        });
      }
    },

    assocMov(){
      console.log('assocMov')
      console.log(this.dataGrid.getSelectedRowsData())
      this.idsAtualizar = this.dataGrid.getSelectedRowKeys()
      console.log('idsAtualizar')
      console.log(this.idsAtualizar)
      console.log(this.idsAtualizar.length)
      if (this.idsAtualizar.length === 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Nenhuma cotação foi selecionada, favor selecionar.",
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        this.showMovalAssocMov = true
      }
    },


    confirmarAssocMov(){
      console.log('confirmarAssocMov')
      this.showMovalAssocMov = false
      this.updating = true
      console.log('vai Atualizar')
      api.get(`${getBaseUrl()}api/fretecotacalcasmov`,{
        params: {
          'ids': this.idsAtualizar,
          'idmov': this.idMovAssoc
        }
      }).then(response => {
        console.log('response.data')
        console.log(response)
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Movimento(s) processado(s) com sucesso!",
          text: response.data,
          showConfirmButton: false,
          timer: 3500
        }).then(() => {
          location.reload()
        })
        this.updating = false
      })
    },


    abrirCotaInterna(){
      console.log('abrirCotaInterna')

      // const routeData = this.$router.resolve(`/cotafrts/listinterna`)
      // window.open(routeData.href, '_blank')



    },


    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))

      this.showModalPeriodo = false
      this.atualizaDataList()
    },


    atualizaDataList(){
      console.log('atualizaDataList_cota')

      const filtros = JSON.parse(localStorage.getItem("filtros"))
      console.log('filtros')
      console.log(filtros)
      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro){
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      this.dataList = new CustomStore({
        key: "id",
        load: function(loadOptions) {
          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
            'di': di,
            'df': df
          }
          return api.get(`${getBaseUrl()}api/fretecotacalcs`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response)
            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })
    },

    carregouGrid(e){
      console.log('carregouGrid')

      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')

      this.title = `(${e.component.totalCount()}) Cotações Internas: ${dtIniFormated} - ${dtFimFormated}`

    },

    onCellPrepared(e) {
      if (e.rowType === "data" && e.data.cotafrt_status === 'CO') {
        e.cellElement.style.cssText = `color: white; background-color:  #34c18e; text-aling: center;`
        return 'valor-frete-notnull';
      } else if (e.rowType === "data" && e.data.cotafrt_status === 'CA') {
        e.cellElement.style.cssText = `color: white; background-color:  #f26e41; text-aling: center;`
        return 'valor-frete-notnull';
      } else if (e.rowType === "data" && e.data.cotafrt_status === 'AB') {
        e.cellElement.style.cssText = `color: black; background-color:  white; text-aling: center;`
        return 'valor-frete-notnull';
      }
    },


    novaCotacao(){
      console.log('novaCotacao')
      this.$router.push({path: "/cotafrt/editar/0", force: true })
    },


    onRowDblClick(row) {
      console.log('onRowDblClick')
      console.log(row.data)
      if (row.data.origem === 'cotafrt') {
        const routeData = this.$router.resolve(`/cotafrt/editar/${row.data.origem_id}`)
        window.open(routeData.href, '_blank')
      }
    },


    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },


    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);
    },


    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

  },



};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>

    <div>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="belloutline"
              hint="Associar a Movimento"
              :on-click="assocMov"/>
        </DxItem>

        <DxItem
            location="before "
            widget="dxButton">

          <DxButton
              text="Nova Cotação"
              style="background-color: #34c38f; color: white;"
              hint="Nova Cotação"
              :on-click="novaCotacao"/>
        </DxItem>


        <DxItem
            location="before"
            widget="dxButton">

          <DxButton
              text="Cotações API"
              style="background-color: #c37434; color: white;"
              hint="Cotações API"
              :on-click="abrirCotaExterna"/>
        </DxItem>

        <DxItem
            location="center"
            locate-in-menu="never">
          <div class="toolbar-label">Listagem de <b>{{ this.title }}</b></div>
        </DxItem>

      </DxToolbar>

    </div>


    <div class="mt-2">

      <DxDataGrid
          key-expr="id"
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          style="text-align: center"
          @cell-prepared="onCellPrepared"
          @content-ready="carregouGrid"
          @row-dbl-click="onRowDblClick"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />
        <DxHeaderFilter :visible="true" />

        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strCotarFrtList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />

        <DxColumn :width="80"
                  sort-order="desc"
                  data-field="id"
                  caption="ID"
                  alignment="right"
                  data-type="number"
                  :fixed="true"
                  fixed-position="left"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="true">
        </DxColumn>

        <DxColumn
            data-field="origem"
            caption="Origem"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>


        <DxColumn data-field="origem_id"
                  caption="Origem ID"
                  alignment="right"
                  data-type="number"
                  :fixed="true"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="true">
        </DxColumn>

        <DxColumn data-field="fretecotabase_id"
                  caption="Base ID"
                  alignment="right"
                  data-type="number"
                  :fixed="true"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="true">
        </DxColumn>

        <DxColumn
            data-field="cubaltu"
            caption="Altura"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>


        <DxColumn
            data-field="cublarg"
            caption="Largura"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="cubcomp"
            caption="Comprimento"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="cubft"
            caption="FT. Cub."
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="pesoinf"
            caption="Peso Informado"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="mcubic"
            caption="M.Cúbico"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="pesocubtotal"
            caption="Peso Cub.Total"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="pesobscalc"
            caption="Peso Base Cálc."
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="fretepeso"
            caption="Frete Peso"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="fretevalor"
            caption="Frete Valor"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="gris"
            caption="GRIS (%)"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>



        <DxColumn
            data-field="tasvlrfixo"
            caption="TAS Vlr.Fixo"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="despachovlrfixo"
            caption="Desp.Vlr.Fixo"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="txsegobrig"
            caption="Tx.Seg.Obrig."
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="subtotal1"
            caption="SubTotal1"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="tsbperc"
            caption="TSB(%)"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="tsbvlrfixo"
            caption="TSB Vlr.Fixo"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="suframavlrfixo"
            caption="Sufr.Vlr.Fixo"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="segfluvperc"
            caption="Seg.Fluv.(%)"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="segfluvvlrfixo"
            caption="Seg.Fluv.Vlr.Fixo"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="subtotal2"
            caption="SubTotal2"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>


        <DxColumn
            data-field="pedagiovlrfixo"
            caption="Ped.Vlr.Fixo"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="pedagiofrac100kg"
            caption="Ped.Frc.100kg"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="pedagiovlrkg"
            caption="Ped.Vlr.Kg"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="coletavlrfixo"
            caption="Coleta Vlr.Fixo"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="coletavlrkg"
            caption="Coleta Vlr.Kg"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="entregavlrfixo"
            caption="Entrega Vlr.Fixo"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="entregavlrkg"
            caption="Entrega Vlr.Kg"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="seccatvlrfixo"
            caption="SECCAT Vlr.Fixo"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="ademeperc"
            caption="ADEME (%)"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="ademevlrfixo"
            caption="ADEME Vlr.Fixo"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="emexperc"
            caption="EMEX (%)"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="emexvlrfixo"
            caption="EMEX Vlr.Fixo"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="emexfrac100kg"
            caption="EMEX Frc.100Kg"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="emexvlrkg"
            caption="EMEX Vlr.Kg"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="subtotal3"
            caption="SubTotal3"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>


        <DxColumn
            data-field="valortrt"
            caption="Valor TRT"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="valortrtfixo"
            caption="Valor TRT Fixo"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="valortda"
            caption="Valor TDA"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="valortdafixo"
            caption="Valor TDA Fixo"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="subtotal4"
            caption="SubTotal4"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="admrodopercfrete"
            caption="Adm.Rodo.Frete(%)"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="txagenda"
            caption="Tx.Agendamento"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="vlrtotalsicms"
            caption="Vlr.Total S/ICMS"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="vlricms"
            caption="Vlr.ICMS"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="vlrtotalcicms"
            caption="Vlr.Total C/ICMS"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="subtotal5"
            caption="SubTotal5"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="subtotal6"
            caption="SubTotal6"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="frtcomppercnota"
            caption="Frete Comp.Nota(%)"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="frtcompkg"
            caption="Frete Comp.Vlr.Kg"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="frtcompmin"
            caption="Frete Comp.Vlr.Min."
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="frtcompperckg"
            caption="Frete Comp.(Kg x %)"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="frtcompsicms"
            caption="Frete Comp.S/ICMS"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>
        <DxColumn
            data-field="frtcompcicms"
            caption="Frete Comp.C/ICMS"
            alignment="right"
            :format="formatDecimal"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>


        <DxColumn
            :width="100"
            data-field="created_at"
            caption="Data"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>


        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>


      </DxDataGrid>


    </div>


    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>




    <b-modal title="Associar Coletas a Movimento"
             size="lg"
             v-model="showMovalAssocMov"
             centered hide-footer>

      <div class="row">
        <div class="col-lg-12">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-2">
                  <p class="text-muted mb-2"> Cotações a associar:</p>
                  <h5 class="mb-0"> {{ idsAtualizar }} </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">

          <div class="mb-3">
            <span>Selecionar Movimento ID: {{ idMovAssoc }}</span>

            <multiselect id="inputRomaneio"
                         @search-change="pesqMovimento"
                         v-model="idMovAssoc"
                         placeholder="Pesquisar movimento"
                         :options="dtListPesqMov"
                         :searchable="true"
                         label="codigo"
                         track-by="codigo"
                         value-prop="id">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="text-info">
                      {{ slotProps.option.id }}
                    </span>
                    <span class="mx-4" >
                      {{ slotProps.option.codigo }}
                    </span>
                  </div>
                  <div class="mt-2 font-size-20">{{ slotProps.option.destnome }}</div>
                  <div class="align-items-end text-end align-content-end">{{ slotProps.option.destcnpj }}</div>
                </div>
              </template>
            </multiselect>

          </div>

          <div class="text-end mt-5">


            <b-button variant="light" @click="showMovalAssocMov = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>


            <!--          <b-button variant="outline-success" @click="confirmarAssocRomaNovo">-->
            <!--            <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>-->
            <!--            Criar e Associar a Novo Romaneio-->
            <!--          </b-button>-->

            <b-button :disabled="idMovAssoc === 0"
                      type="submit" variant="success" class="ms-1" @click="confirmarAssocMov()">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>

          </div>
        </div>
      </div>
    </b-modal>


  </Layout>
</template>